export default "__VITE_ASSET__CSjboCsh__";